import { cva } from 'class-variance-authority';

// The separator is an absolutely positioned child rather than a `border-t` so
// it does not add a 73rd pixel to the 16 + 40 + 16 box.
export const footerVariants = cva([
  'flex',
  'w-full',
  'items-center',
  'justify-between',
  'gap-spacing-sys-spacing-8',
  'p-spacing-ref-default',
  'relative',
]);

export const leadingVariants = cva([
  'flex',
  'min-w-0',
  'flex-1',
  'items-center',
  'gap-spacing-sys-spacing-8',
]);

export const trailingVariants = cva([
  'flex',
  'shrink-0',
  'items-center',
  'gap-spacing-sys-spacing-8',
]);
